import { Component } from '@angular/core';
import { EventType, NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/services/common.service';
import { EventsService } from 'src/services/events.service';


@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss']
})

export class EventListComponent {
  eventTypes: any[] = [];
  eventDetails: any;
  activeEventType: string;
  isUpcomingEvents: boolean = false;
  isOnlineEvents: boolean = false;
  allEvents: boolean = false;
  eventDetailsId: any;
  wishlistBadge = 0;
  wishlistarr: any[] = []

  constructor(public commonService: CommonService,
    public eventService: EventsService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService) {
    this.activeEventType = 'UPCOMING';
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
      }
    });
  }
  private scrollToTop() {
    window.scrollTo(0, 0);

  }
  ngOnInit() {
    this.spinner.show();
    const spinnerDuration = 2000;
    setTimeout(() => {
      this.getAllEventsTypes();
      this.GetEventsOnClick(this.activeEventType);
    }, spinnerDuration);
  }

  //**************** Get Data From Local Json Events Type (Buttons of Events) ***************************

  getAllEventsTypes() {
    let url = './assets/eventTypes.json'
    this.commonService.get(url).subscribe((data: any) => {
      this.eventTypes = data;
      this.spinner.hide();
    })
  }

  //************ when we Click on All Events, Online , Upcoming this click event comes data*************

  setActiveEventType(eventType: any) {
    this.spinner.show();
    this.activeEventType = eventType;
    this.GetEventsOnClick(eventType)
  }


  //****************************** API Of all Type Of Events List **************************************

  GetEventsOnClick(activeEventType: string) {
    this.spinner.show();
    this.eventService.GetEventsModeList(activeEventType).subscribe((respEventsList: any) => {
      if (respEventsList.isSuccessful === true) {
        this.eventDetails = respEventsList.data;
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
      }
    }),
      (error: any) => {
        this.toaster.error(error.messageDetail.message, 'Error');
      }
  }

  //**************************************** WishList *********************************************** */


  addToWishlist(details: any) {
    const index = this.wishlistarr.findIndex(item => item.eventId === details.eventId);

    if (index !== -1) {
      // Item is in the wishlist, remove it
      details.isInWishlist = false;
      this.wishlistarr.splice(index, 1);
      this.wishlistBadge = this.wishlistarr.length;
      this.commonService.wishlistData.next(this.wishlistarr)
    } else {
      // Item is not in the wishlist, add it
      details.isInWishlist = true;
      this.wishlistarr.push(details);
      this.wishlistBadge = this.wishlistarr.length;
      details.wishlistBadge = this.wishlistBadge
      this.commonService.wishlistData.next(this.wishlistarr)
    }
  }

  //****************** Send event details ID to next component {event-details} ************************/

  showMoreDetails(id: any) {
    this.router.navigate(['event-details/' + id],);
  }

}